<template>
            <!-- v-model:value="value.card_id"
        :disabled="saving"
        :options="cards"
        valueKey="id"
        selectedCSS=""
        @update:value="checkForAddNew" -->

    <Select
        selectClass="!bg-grey text-15"
        menuClass="!bg-grey"
        name="card_id"
        label="Select card"
        placeholder="Select a card"
        v-bind="$attrs"
    >
        <template #label-right>
            <button v-if='!hideAddNewCard' class="link-text text-purple-600 text-13" type="button" @click="addNew()">Add new card</button>
        </template>

        <template #option="{ option, selected }">
            <div class="flex items-center w-full" v-if="option.html != 'Add new card'">
                <PaymentMethodTable :paymentMethod="option" :table="false" class='!font-normal' />

                <div class="flex items-center ml-4" v-if="option.default_payment_method != null && !selected">
                    <IconTrue class="stroke-white w-5 h-5 bg-black rounded-full" />

                    <p class="text-15 pl-2">Default</p>
                </div>
            </div>

            <p v-else>{{ option.html }}</p>
        </template>
    </Select>
</template>

<script>
    export default {
        props: {
            lastModal: {
                type: Object,
                default: null
            },
            hideAddNewCard: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            addNew() {
                this.$event.$emit('modal-open', {
                    view: 'PaymentMethodCreate',
                    lastModal: this.lastModal
                })
            },
        }
    }
</script>